import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseUser, faGear, faUserSlash, faUser, faPlugCircleExclamation, faPlugCircleBolt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { State } from "../../types";
import { closeWindow, openWindow } from "../../actions";
import { Modal, Form } from "react-bootstrap";
import { login, logout } from "../../actions/userActions";
import { useState } from "react";
import { baseURI, baseURL, socket } from "../../api";
import AppModal from "../Common/AppModal";
import AppButton from "../Common/AppButton";

const Header: React.FC = () => {
    const userStatus = useSelector((store: State) => store.userStatus)
    const currentCharacterId = useSelector((store: State) => store.currentCharacterId)
    const gameInstance = useSelector((store: State) => store.gameInstance)
    const settings = useSelector((store: State) => store.settings);
    const dispatch: any = useDispatch();
    const navigate = useNavigate();

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const destroyGameInstance = () => {
        if (window.confirm("Destroy game instance?")) {
            if (gameInstance) {
                socket.emit("exitGame", {charId: currentCharacterId, gameInstanceId: gameInstance.id})
                navigate(`${baseURI}`)
            }
        }
    }

    return (
        <>
            <div className="px-2" style={{
                height: "45px",
                lineHeight: "50px",
                width: "100%",
                position: "fixed",
                top: 0,
                // backgroundColor: "rgba(0,0,0,0.25)"
            }}>
                <div className="dropdown">
                    <button className="btn btn-theme-white-noborder" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{backgroundImage: "url(/img/ui/btn_02.png)"}}>
                        Menu
                    </button>
                    <ul className="dropdown-menu dropdown-theme-white animate slideIn w-100 p-0" aria-labelledby="dropdownMenuButton1" style={{ lineHeight: 1.5, backgroundImage: `url(${baseURL}/img/ui/bg_noise.png)` }}>
                        <li><Link className="clickable dropdown-item px-2 py-1" to={baseURI}><span className="d-inline-block" style={{ width: "25px" }}><FontAwesomeIcon icon={faHouseUser} /></span><span className="">Home</span></Link></li>
                        {gameInstance && <li><span className="clickable dropdown-item px-2 py-1" onClick={destroyGameInstance}><span className="d-inline-block" style={{ width: "25px" }}><FontAwesomeIcon icon={faTrash} /></span><span className="">End Story</span></span></li>}
                        <li><span className="clickable dropdown-item px-2 py-1" onClick={() => { dispatch(openWindow("settings")) }}><span className="d-inline-block" style={{ width: "25px" }}><FontAwesomeIcon icon={faGear} /></span><span className="">Settings</span></span></li>
                        <li><span className="clickable dropdown-item px-2 py-1" onClick={() => { dispatch(openWindow("user")) }}><span className="d-inline-block" style={{ width: "25px" }}><FontAwesomeIcon icon={faUser} /></span><span className="">Account</span></span></li>
                    </ul>
                    <span className="float-end px-1">
                        {!userStatus.installationActive ?
                            <FontAwesomeIcon className="ms-2" icon={faUserSlash} size={"1x"} />
                            :
                            <FontAwesomeIcon className="ms-2" icon={faUser} size={"1x"} />
                        }
                    </span>
                    <span className="float-end px-1">
                        { settings.socketStatus === "disconnected" && <FontAwesomeIcon title="Disconnected" opacity={0.25} className="ms-2" icon={faPlugCircleExclamation} size={"1x"}  /> }
                        { settings.socketStatus === "connected" && <FontAwesomeIcon title="Unauthenticated" opacity={0.25} className="ms-2" icon={faPlugCircleExclamation} size={"1x"} /> }
                        { settings.socketStatus === "authenticated" && <FontAwesomeIcon title="Connected" className="ms-2" icon={faPlugCircleBolt} size={"1x"} /> }
                    </span>
                </div>

                <AppModal name="login" title="Login" preventClosing>
                    <Modal.Body className="p-3">
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control className="semi-transparent" type="email" value={username} onChange={(e) => { setUsername(e.target.value); }} placeholder="name@example.com" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Password</Form.Label>
                                <Form.Control className="semi-transparent" type="password" value={password} onChange={(e) => { setPassword(e.target.value); }} />
                            </Form.Group>
                            <AppButton className="" onClick={() => { dispatch(login(username, password)); setUsername(""); setPassword(""); }} variant="danger">Login</AppButton>
                        </Form>
                    </Modal.Body>
                </AppModal>

                <AppModal name="user" title="Account">
                    <Modal.Body className="p-3">
                        <div className="mb-4">
                            <div>
                                Name: {userStatus.displayName}
                            </div>
                            <div>
                                Email: {userStatus.emailAddress}
                            </div>
                        </div>
                        <AppButton className="" variant="secondary" onClick={() => { dispatch(logout()) }}>
                            Logout
                        </AppButton>
                    </Modal.Body>
                    <Modal.Footer className="p-1">
                        <AppButton className="" variant="secondary" onClick={() => { dispatch(closeWindow("user")) }}>
                            Close
                        </AppButton>
                    </Modal.Footer>
                </AppModal>

                <AppModal name="settings" title="Settings">
                    <Modal.Body className="p-1">

                    </Modal.Body>
                    <Modal.Footer className="p-1">
                        <AppButton className="" variant="secondary" onClick={() => { dispatch(closeWindow("settings")) }}>
                            Close
                        </AppButton>
                    </Modal.Footer>
                </AppModal>

                <AppModal name="about" title="About">
                    <Modal.Body className="p-3">
                        About
                    </Modal.Body>
                    <Modal.Footer className="p-1">
                        <AppButton className="" variant="secondary" onClick={() => { dispatch(closeWindow("about")) }}>
                            Close
                        </AppButton>
                    </Modal.Footer>
                </AppModal>

            </div>
        </>
    );
}

export default Header;